<template>
    <date-picker-erp
      :value="self_value"
      placeholder="选择日期时间"
      time-type="datetime"
      value-format="YYYY-MM-DD HH:mm:ss"
      v-bind="props"
      @change="onChange"
    ></date-picker-erp>
</template>

<script>
export default {
  props: ["props", "value"],
  computed: {
    key() {
      return this.props.name
    },
    self_value() {
        return {start: this.value}
    }
  },
  methods: {
      onChange(v) {
          this.$emit('change', v ? v.start : '')
      }
  }
}
</script>

<style></style>